<template>
  <div>
    <v-row dense>
      <v-col cols="6" sm="6" md="6">
        <v-card outlined>
          <v-list-item>
            <v-list-item-avatar :color="totalStatusDisplay.colorLighten">
              <v-icon :color="totalStatusDisplay.colorDarken">
                {{ totalStatusDisplay.icon }}
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{
                totalStatusDisplay.text
              }}</v-list-item-title>
              <v-list-item-subtitle>Status (Gesamt)</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6" sm="6" md="6">
        <v-card outlined>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>DD.MM.YYYY</v-list-item-title>
              <v-list-item-subtitle>Nächster Cut-Off</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "performance-target-personal-result-view",
  components: {},
  props: {
    totalStatus: {
      type: String,
      required: true,
    },
  },
  computed: {
    totalStatusDisplay() {
      const status = this.totalStatus;
      switch (status) {
        case "met":
          return {
            text: "Erfüllt",
            icon: "mdi-check-circle",
            colorDarken: "green darken-2",
            colorLighten: "green lighten-4",
          };
        case "notMet":
          return {
            text: "Nicht erfüllt",
            icon: "mdi-close",
            colorDarken: "red darken-2",
            colorLighten: "red lighten-4",
          };
        case "notApplicable":
          return {
            text: "Nicht anwendbar",
            icon: "mdi-help",
            colorDarken: "purple darken-2",
            colorLighten: "purple lighten-4",
          };
        case "unknown":
        default:
          return {
            text: "Unbekannt",
            icon: "mdi-help",
            colorDarken: "grey darken-2",
            colorLighten: "grey lighten-4",
          };
      }
    },
  },
  methods: {},
};
</script>
